// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1AVfB","description":"PatientConsentPreview_description__36ijP"};